import React, { useState } from "react";
import { Box, Container, Typography } from "@mui/material";
import TiltCard from "./ui/TiltCard";

const logos = [
  "/assets/clients/mb.jpeg",
  "/assets/clients/phani.jpeg",
  "/assets/clients/dental.jpeg",
  "/assets/clients/sam.jpeg",
];

// Dual-direction marquee: rows drift opposite ways, pause on hover, and fade
// out at the edges via a CSS mask instead of hard-cutting logos mid-frame.
function MarqueeRow({ items, direction, duration }) {
  const [paused, setPaused] = useState(false);
  const track = [...items, ...items];

  return (
    <Box
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      sx={{
        overflow: "hidden",
        position: "relative",
        py: 1,
        WebkitMaskImage:
          "linear-gradient(90deg, transparent 0%, #000 10%, #000 90%, transparent 100%)",
        maskImage:
          "linear-gradient(90deg, transparent 0%, #000 10%, #000 90%, transparent 100%)",
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          gap: { xs: 3, md: 5 },
          animation: `${direction === "left" ? "marquee-left" : "marquee-right"} ${duration}s linear infinite`,
          animationPlayState: paused ? "paused" : "running",
          "@keyframes marquee-left": {
            from: { transform: "translateX(0)" },
            to: { transform: "translateX(-50%)" },
          },
          "@keyframes marquee-right": {
            from: { transform: "translateX(-50%)" },
            to: { transform: "translateX(0)" },
          },
        }}
      >
        {track.map((logo, index) => (
          <TiltCard
            key={index}
            maxTilt={12}
            scale={1.05}
            glareColor="#FD8112"
            glareOpacity={0.22}
            style={{ flexShrink: 0 }}
          >
            <Box
              sx={{
                width: { xs: 130, md: 168 },
                height: { xs: 84, md: 104 },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 3,
                background: "rgba(20,20,31,0.03)",
                border: "1px solid rgba(20,20,31,0.08)",
                transition: "box-shadow 0.3s ease, border-color 0.3s ease",
                "&:hover": {
                  boxShadow: "0 16px 32px rgba(253,129,18,0.2)",
                  borderColor: "rgba(253,129,18,0.35)",
                },
                "&:hover img": {
                  filter: "grayscale(0%) opacity(1)",
                },
              }}
            >
              <Box
                component="img"
                src={logo}
                alt={`Client logo ${index + 1}`}
                loading="lazy"
                sx={{
                  maxHeight: "68%",
                  maxWidth: "68%",
                  objectFit: "contain",
                  filter: "grayscale(100%) opacity(0.55)",
                  transition: "filter 0.35s ease",
                }}
              />
            </Box>
          </TiltCard>
        ))}
      </Box>
    </Box>
  );
}

export default function ClientLogos() {
  return (
    <Box
      sx={{
        py: { xs: 6, md: 8 },
        backgroundColor: "#F8F8FB",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          sx={{
            textAlign: "center",
            fontWeight: 800,
            fontFamily: "Poppins, sans-serif",
            color: "#14141F",
            mb: 1,
          }}
        >
          Trusted By Our Clients
        </Typography>
        <Typography
          sx={{
            textAlign: "center",
            color: "#5B5B6E",
            mb: { xs: 4, md: 6 },
            fontSize: "0.95rem",
          }}
        >
          Brands across industries rely on SLGT to grow their digital presence.
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <MarqueeRow items={logos} direction="left" duration={22} />
          <MarqueeRow items={[...logos].reverse()} direction="right" duration={26} />
        </Box>
      </Container>
    </Box>
  );
}
